import {Exercise, SelectedExerciseData} from './ExerciseLibraryModal.type';

export class ExerciseLibraryModalMap {
  static toSelectOption(exercise: Exercise) {
    return {
      label: exercise.name,
      value: exercise.id,
      animatedImage: exercise.animatedImage,
      image: exercise.image,
    };
  }

  static toWorkoutExercise(exerciseData: SelectedExerciseData) {
    return {
      id: '',
      tempId: new Date().getTime(),
      exerciseId: exerciseData.exercise.id,
      exercise: this.toSelectOption(exerciseData.exercise),
      series: exerciseData.series || '',
      reps: exerciseData.reps || '',
      weight: exerciseData.weight || '',
      time: exerciseData.time || '',
      restTime: exerciseData.restTime || '',
      notes: exerciseData.notes || '',
    };
  }

  static formatExercisePreviewData(exerciseData: SelectedExerciseData) {
    const exercise = exerciseData.exercise;
    if (!exercise) return null;

    return {
      name: exercise.name,
      description: exercise.description || 'Nenhuma descrição disponível',
      imageUrl: this.getImageUrl(exercise),
      formData: {
        series: exerciseData.series || '',
        reps: exerciseData.reps || '',
        weight: exerciseData.weight || '',
        time: exerciseData.time || '',
        restTime: exerciseData.restTime || '',
        notes: exerciseData.notes || '',
      },
    };
  }

  static getImageUrl(exercise: Exercise): string | null {
    if (exercise.animatedImage?.uriOriginal) {
      return exercise.animatedImage.uriOriginal;
    }
    if (exercise.animatedImage?.uri) {
      return exercise.animatedImage.uri;
    }
    if (exercise.image?.uri) {
      return exercise.image.uri;
    }
    if (exercise.image?.uriOriginal) {
      return exercise.image.uriOriginal;
    }
    return null;
  }

  static formatMuscleGroups(muscleGroups: string[]): string {
    if (!muscleGroups || muscleGroups.length === 0) {
      return 'Não especificado';
    }
    return muscleGroups.join(', ');
  }

  static formatEquipment(equipment: string[]): string {
    if (!equipment || equipment.length === 0) {
      return 'Não especificado';
    }
    return equipment.join(', ');
  }
}
